module.exports = __webpack_public_path__ + "img/106ne.85a7f463.svg";